import React from 'react';
import { Form, Input, Select, Button, Switch, Divider } from 'antd';
import Config from './../config';


class QRForm extends React.Component {
    onSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.onSubmit(values);
            }
        });
    };

    validateURL = (rule, str, callback) => {
        let pattern = new RegExp('^(https?:\\/\\/)?'+
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+
            '((\\d{1,3}\\.){3}\\d{1,3}))'+
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+
            '(\\?[;&a-z\\d%_.~+=-]*)?'+
            '(\\#[-a-z\\d_]*)?$','i');
        if (!pattern.test(str)) {
            callback(`Insert correct url`);
        } else {
            callback();
        }
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const item = this.props.item;
        return (
            <React.Fragment>
                <Form onSubmit={this.onSubmit}>
                    <Form.Item label={`Name`}>
                        {getFieldDecorator('name', {
                            initialValue: item.name || "",
                            rules: [
                                {required: true, message: 'Select qr name'}
                            ]
                        })(
                            <Select placeholder={`Select name`}>
                                {Config.QR_NAMES.map(i => <Select.Option value={i} key={`name_${i}`}>{i}</Select.Option>)}
                            </Select>
                        )}
                    </Form.Item>
                    <Form.Item label={`Note`}>
                        {getFieldDecorator('note', {
                            initialValue: item.note || "",
                        })(
                           <Input placeholder={`Enter note for file`} />
                        )}
                    </Form.Item>
                    <Form.Item label={`Source url`}>
                        {getFieldDecorator('original_url', {
                            initialValue: item.original_url || "",
                            rules: [
                                {required: true, message: `Fill source url field`},
                                {validator: this.validateURL}
                            ]
                        })(<Input placeholder={`Enter url like https://www.rt.com`} />)}
                    </Form.Item>
                    <Form.Item label={`Active`}>
                        {getFieldDecorator('active', {
                            initialValue: item.active || true,
                            valuePropName: 'checked'
                        })(<Switch />)}
                    </Form.Item>
                    <Divider>UTMS</Divider>
                    <Form.Item label={`UTM source`}>
                        {getFieldDecorator('utms.source', {
                            initialValue: item.utms && item.utms.source ? item.utms.source : 'rt',
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label={`UTM medium`}>
                        {getFieldDecorator('utms.medium', { initialValue: item.utms && item.utms.medium ? item.utms.medium : 'tv' })(<Input />)}
                    </Form.Item>
                    <Form.Item label={`UTM campaign`}>
                        {getFieldDecorator('utms.campaign', { initialValue: item.utms && item.utms.campaign ? item.utms.campaign : 'qrcode' })(<Input />)}
                    </Form.Item>
                    <Form.Item>
                        <Button type={`primary`} htmlType={`submit`}>{item.id ? `Update` : `Create`}</Button>
                    </Form.Item>
                </Form>
            </React.Fragment>
        );
    }
}


const WrappedQRForm = Form.create({ name: 'QRForm' })(QRForm);

export default WrappedQRForm;



// WEBPACK FOOTER //
// ./src/components/qr.form.js